import { render, staticRenderFns } from "./CriterioGetHighlightProducts.vue?vue&type=template&id=0f1639a4"
import script from "./CriterioGetHighlightProducts.vue?vue&type=script&lang=js"
export * from "./CriterioGetHighlightProducts.vue?vue&type=script&lang=js"
import style0 from "./CriterioGetHighlightProducts.vue?vue&type=style&index=0&id=0f1639a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports